import { render, staticRenderFns } from "./AuditLogsDiff.vue?vue&type=template&id=21031dee"
import script from "./AuditLogsDiff.vue?vue&type=script&lang=js"
export * from "./AuditLogsDiff.vue?vue&type=script&lang=js"
import style0 from "./AuditLogsDiff.vue?vue&type=style&index=0&id=21031dee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports